import TherapySideApiService from "./utils/TherapyApi";
import type { ReassignApi, ReassignRequestApiQuery } from "@/Modules/Reassign/Models/Api/ReassignApi";
import type { ReassignStatusApiQuery } from "@/Modules/Reassign/Models/Api/ReassignApi";

class ReassignApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  async reassignRequest(userId: string): Promise<ReassignApi> {
    return this.ApiService.post<ReassignRequestApiQuery, ReassignApi>({
      endpoint: `v1.0/reassign-request`,
      body: { user_uuid: userId },
    });
  }

  async reassignStatus(userId: string): Promise<ReassignApi[]> {
    return this.ApiService.get<ReassignStatusApiQuery, ReassignApi[]>({
      endpoint: `v1.0/reassign-request`,
      params: { user_uuid: userId, is_reassigned: false },
    });
  }
}

export default ReassignApiConnector;
